<template>
    <div class="contain">
		<audio src="https://music.163.com/song/media/outer/url?id=2014542879.mp3" ref="music" loop></audio>
        <BoundMenu></BoundMenu>
        <div class="main">
            <div class="main-top">
                <span>到底什么样的结局会配得上我们这一路的颠沛流离？# 2024 数学派加油</span>
                <span class="main-top-music">
                    <span>《数学系和银河系邂逅》</span>
                    <svg v-if="!music" @click="ListenMusic" t="1706371360188" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="985" width="20" height="20"><path d="M500.864 83.392c239.68 0 434.656 194.976 434.656 434.624 0 239.648-195.008 434.656-434.656 434.656S66.24 757.664 66.24 518.016 261.216 83.392 500.864 83.392m0 933.28c274.944 0 498.656-223.712 498.656-498.656S775.84 19.392 500.864 19.392C225.92 19.392 2.24 243.072 2.24 518.016S225.92 1016.672 500.864 1016.672" fill="#ffffff" p-id="986"></path><path d="M436.864 412.512l189.024 105.504-189.024 105.504v-211.008z m-32 297.504a31.04 31.04 0 0 0 15.36-4.48l0.224 0.416 286.72-160-0.256-0.416a31.584 31.584 0 0 0 16.64-27.52 31.552 31.552 0 0 0-16.64-27.52l0.224-0.416-286.688-160-0.224 0.416a30.72 30.72 0 0 0-15.36-4.48 32 32 0 0 0-32 32v320a32 32 0 0 0 32 32z" fill="#DEE0EC" p-id="987"></path></svg>
                    <svg v-else @click="CloseMusic" t="1706371482884" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1316" id="mx_n_1706371482885" width="20" height="20"><path d="M500.864 952.64c-239.648 0-434.656-194.976-434.656-434.624 0-239.68 195.008-434.624 434.656-434.624 239.68 0 434.656 194.944 434.656 434.624 0 239.68-195.008 434.624-434.656 434.624m0-933.28C225.92 19.36 2.24 243.104 2.24 518.016 2.24 792.96 225.92 1016.64 500.864 1016.64s498.656-223.68 498.656-498.624c0-274.912-223.68-498.624-498.656-498.624" fill="#DEE0EC" p-id="1317"></path><path d="M404.864 326.016a32 32 0 0 0-32 32v320a32 32 0 0 0 64 0v-320a32 32 0 0 0-32-32M596.864 326.016a32 32 0 0 0-32 32v320a32 32 0 0 0 64 0v-320a32 32 0 0 0-32-32" fill="#ffffff" p-id="1318"></path></svg>
                </span>
            </div>
            <div class="main-image">
                <div class="main-image-line">
                    <span></span>
                </div>
                <div class="main-image-info">
                    <img class="main-image-logo" src="./../assets/img/logo_black.jpg" alt="">
                    <div class="main-image-name" style="font-size: 50px;">MSLM MATHS PIE</div>
                </div>

                <div class="image-menu">
      
                </div>
            </div>

            <div class="main-title">
                <span style="font-size: 18px;">秒数联盟数学派热点新闻</span>
            </div>

            <div class="main-bottom">
                <div class="main-bottom-date"></div>
                <div class="main-bottom-content">
                    <div class="latest-new">
                        <svg t="1708869584556" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8685" width="45" height="45"><path d="M1006.762667 443.682133l-129.0752 324.488533-109.806933 0c4.864-39.645867 12.151467-91.886933 21.8624-156.740267-10.5472 28.535467-22.186667 57.309867-34.9696 86.3232l-30.3616 70.417067-110.062933 0 45.806933-324.488533 87.1936 0c-1.655467 8.482133-11.2128 70.417067-28.689067 185.838933 4.352-11.8784 28.859733-73.8304 73.5232-185.838933l83.7632 0L845.653333 629.504c18.0736-54.272 42.734933-116.206933 74.001067-185.838933L1006.762667 443.665067zM608.768 603.8016l-138.666667 0-20.309333 78.4384c-4.2496 16.401067-5.8368 26.965333-4.7616 31.709867 1.0752 4.744533 4.881067 7.099733 11.4176 7.099733 8.123733 0 14.370133-3.140267 18.7392-9.4208 4.369067-6.280533 8.891733-18.449067 13.550933-36.488533l12.3904-47.8208 101.546667 0-6.929067 26.7776c-5.802667 22.408533-11.6224 39.6288-17.476267 51.6608-5.853867 12.032-15.581867 24.866133-29.201067 38.536533-13.6192 13.6704-29.0304 23.9104-46.267733 30.737067-17.237333 6.826667-37.512533 10.257067-60.842667 10.257067-22.6304 0-41.728-3.3792-57.309867-10.103467-15.581867-6.741333-26.658133-15.991467-33.245867-27.733333-6.587733-11.758933-9.915733-24.695467-9.966933-38.8096-0.0512-14.114133 3.413333-34.6624 10.3936-61.627733l27.374933-105.762133c8.209067-31.709867 18.8416-56.712533 31.880533-75.025067 13.038933-18.312533 30.293333-32.341333 51.729067-42.0864 21.435733-9.745067 44.4416-14.626133 69.000533-14.626133 30.0544 0 53.316267 5.870933 69.802667 17.629867 16.4864 11.758933 26.146133 27.323733 28.996267 46.728533 2.833067 19.4048-0.290133 46.6944-9.386667 81.851733L608.768 603.8016zM520.209067 473.719467c-7.424 0-12.629333 2.321067-15.581867 6.9632-2.9696 4.642133-7.099733 17.169067-12.373333 37.5808L485.376 544.768l31.2832 0 6.8608-26.504533c4.864-18.773333 7.0144-30.890667 6.485333-36.352C529.493333 476.450133 526.216533 473.719467 520.209067 473.719467zM431.342933 400.503467c-23.6032 10.376533-42.5984 25.2928-56.951467 44.782933-14.370133 19.490133-26.077867 46.08-35.106133 79.8208l-30.1568 112.5376c-7.68 28.689067-11.502933 50.551467-11.434667 65.570133 0.068267 15.018667 3.720533 28.791467 10.973867 41.284267 7.253333 12.509867 19.456 22.340267 36.608 29.508267 0.7168 0.290133 1.536 0.494933 2.2528 0.785067l-2.884267 10.496-128.529067 0-7.867733-248.4736L139.844267 785.271467 17.237333 785.271467l150.493867-546.56 122.606933 0 14.4384 246.101333 67.771733-246.101333 122.606933 0-42.427733 154.112C445.457067 394.990933 438.289067 397.448533 431.342933 400.503467z" fill="#FFFFFF" p-id="8686"></path></svg>
                        <div>热点新闻：2024-09-28 数学派《数学系和银河系邂逅》网易云随时畅听</div>
                        <a href="https://music.163.com/#/song?id=2014542879" target="_blank">查看详细</a>
                    </div>
                    <div class="latest-new">
                        <svg t="1708869584556" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8685" width="45" height="45"><path d="M1006.762667 443.682133l-129.0752 324.488533-109.806933 0c4.864-39.645867 12.151467-91.886933 21.8624-156.740267-10.5472 28.535467-22.186667 57.309867-34.9696 86.3232l-30.3616 70.417067-110.062933 0 45.806933-324.488533 87.1936 0c-1.655467 8.482133-11.2128 70.417067-28.689067 185.838933 4.352-11.8784 28.859733-73.8304 73.5232-185.838933l83.7632 0L845.653333 629.504c18.0736-54.272 42.734933-116.206933 74.001067-185.838933L1006.762667 443.665067zM608.768 603.8016l-138.666667 0-20.309333 78.4384c-4.2496 16.401067-5.8368 26.965333-4.7616 31.709867 1.0752 4.744533 4.881067 7.099733 11.4176 7.099733 8.123733 0 14.370133-3.140267 18.7392-9.4208 4.369067-6.280533 8.891733-18.449067 13.550933-36.488533l12.3904-47.8208 101.546667 0-6.929067 26.7776c-5.802667 22.408533-11.6224 39.6288-17.476267 51.6608-5.853867 12.032-15.581867 24.866133-29.201067 38.536533-13.6192 13.6704-29.0304 23.9104-46.267733 30.737067-17.237333 6.826667-37.512533 10.257067-60.842667 10.257067-22.6304 0-41.728-3.3792-57.309867-10.103467-15.581867-6.741333-26.658133-15.991467-33.245867-27.733333-6.587733-11.758933-9.915733-24.695467-9.966933-38.8096-0.0512-14.114133 3.413333-34.6624 10.3936-61.627733l27.374933-105.762133c8.209067-31.709867 18.8416-56.712533 31.880533-75.025067 13.038933-18.312533 30.293333-32.341333 51.729067-42.0864 21.435733-9.745067 44.4416-14.626133 69.000533-14.626133 30.0544 0 53.316267 5.870933 69.802667 17.629867 16.4864 11.758933 26.146133 27.323733 28.996267 46.728533 2.833067 19.4048-0.290133 46.6944-9.386667 81.851733L608.768 603.8016zM520.209067 473.719467c-7.424 0-12.629333 2.321067-15.581867 6.9632-2.9696 4.642133-7.099733 17.169067-12.373333 37.5808L485.376 544.768l31.2832 0 6.8608-26.504533c4.864-18.773333 7.0144-30.890667 6.485333-36.352C529.493333 476.450133 526.216533 473.719467 520.209067 473.719467zM431.342933 400.503467c-23.6032 10.376533-42.5984 25.2928-56.951467 44.782933-14.370133 19.490133-26.077867 46.08-35.106133 79.8208l-30.1568 112.5376c-7.68 28.689067-11.502933 50.551467-11.434667 65.570133 0.068267 15.018667 3.720533 28.791467 10.973867 41.284267 7.253333 12.509867 19.456 22.340267 36.608 29.508267 0.7168 0.290133 1.536 0.494933 2.2528 0.785067l-2.884267 10.496-128.529067 0-7.867733-248.4736L139.844267 785.271467 17.237333 785.271467l150.493867-546.56 122.606933 0 14.4384 246.101333 67.771733-246.101333 122.606933 0-42.427733 154.112C445.457067 394.990933 438.289067 397.448533 431.342933 400.503467z" fill="#FFFFFF" p-id="8686"></path></svg>
                        <div>热点新闻：2024-09-27 数学派亿题云资料宝库官网界面UI全面优化升级</div>
                        <a href="http://cloud.mslmsxp.com/" target="_blank">查看详细</a>
                    </div>
                    <div class="latest-new">
                        <svg t="1708869584556" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8685" width="45" height="45"><path d="M1006.762667 443.682133l-129.0752 324.488533-109.806933 0c4.864-39.645867 12.151467-91.886933 21.8624-156.740267-10.5472 28.535467-22.186667 57.309867-34.9696 86.3232l-30.3616 70.417067-110.062933 0 45.806933-324.488533 87.1936 0c-1.655467 8.482133-11.2128 70.417067-28.689067 185.838933 4.352-11.8784 28.859733-73.8304 73.5232-185.838933l83.7632 0L845.653333 629.504c18.0736-54.272 42.734933-116.206933 74.001067-185.838933L1006.762667 443.665067zM608.768 603.8016l-138.666667 0-20.309333 78.4384c-4.2496 16.401067-5.8368 26.965333-4.7616 31.709867 1.0752 4.744533 4.881067 7.099733 11.4176 7.099733 8.123733 0 14.370133-3.140267 18.7392-9.4208 4.369067-6.280533 8.891733-18.449067 13.550933-36.488533l12.3904-47.8208 101.546667 0-6.929067 26.7776c-5.802667 22.408533-11.6224 39.6288-17.476267 51.6608-5.853867 12.032-15.581867 24.866133-29.201067 38.536533-13.6192 13.6704-29.0304 23.9104-46.267733 30.737067-17.237333 6.826667-37.512533 10.257067-60.842667 10.257067-22.6304 0-41.728-3.3792-57.309867-10.103467-15.581867-6.741333-26.658133-15.991467-33.245867-27.733333-6.587733-11.758933-9.915733-24.695467-9.966933-38.8096-0.0512-14.114133 3.413333-34.6624 10.3936-61.627733l27.374933-105.762133c8.209067-31.709867 18.8416-56.712533 31.880533-75.025067 13.038933-18.312533 30.293333-32.341333 51.729067-42.0864 21.435733-9.745067 44.4416-14.626133 69.000533-14.626133 30.0544 0 53.316267 5.870933 69.802667 17.629867 16.4864 11.758933 26.146133 27.323733 28.996267 46.728533 2.833067 19.4048-0.290133 46.6944-9.386667 81.851733L608.768 603.8016zM520.209067 473.719467c-7.424 0-12.629333 2.321067-15.581867 6.9632-2.9696 4.642133-7.099733 17.169067-12.373333 37.5808L485.376 544.768l31.2832 0 6.8608-26.504533c4.864-18.773333 7.0144-30.890667 6.485333-36.352C529.493333 476.450133 526.216533 473.719467 520.209067 473.719467zM431.342933 400.503467c-23.6032 10.376533-42.5984 25.2928-56.951467 44.782933-14.370133 19.490133-26.077867 46.08-35.106133 79.8208l-30.1568 112.5376c-7.68 28.689067-11.502933 50.551467-11.434667 65.570133 0.068267 15.018667 3.720533 28.791467 10.973867 41.284267 7.253333 12.509867 19.456 22.340267 36.608 29.508267 0.7168 0.290133 1.536 0.494933 2.2528 0.785067l-2.884267 10.496-128.529067 0-7.867733-248.4736L139.844267 785.271467 17.237333 785.271467l150.493867-546.56 122.606933 0 14.4384 246.101333 67.771733-246.101333 122.606933 0-42.427733 154.112C445.457067 394.990933 438.289067 397.448533 431.342933 400.503467z" fill="#FFFFFF" p-id="8686"></path></svg>
                        <div>热点新闻：2024-09-25 数学派迷你英语单词猫官网手机端更新智能刷题功能</div>
                        <a href="http://cat.mslmsxp.com/" target="_blank">查看详细</a>
                    </div>
                    <div class="latest-new">
                        <svg t="1708869584556" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8685" width="45" height="45"><path d="M1006.762667 443.682133l-129.0752 324.488533-109.806933 0c4.864-39.645867 12.151467-91.886933 21.8624-156.740267-10.5472 28.535467-22.186667 57.309867-34.9696 86.3232l-30.3616 70.417067-110.062933 0 45.806933-324.488533 87.1936 0c-1.655467 8.482133-11.2128 70.417067-28.689067 185.838933 4.352-11.8784 28.859733-73.8304 73.5232-185.838933l83.7632 0L845.653333 629.504c18.0736-54.272 42.734933-116.206933 74.001067-185.838933L1006.762667 443.665067zM608.768 603.8016l-138.666667 0-20.309333 78.4384c-4.2496 16.401067-5.8368 26.965333-4.7616 31.709867 1.0752 4.744533 4.881067 7.099733 11.4176 7.099733 8.123733 0 14.370133-3.140267 18.7392-9.4208 4.369067-6.280533 8.891733-18.449067 13.550933-36.488533l12.3904-47.8208 101.546667 0-6.929067 26.7776c-5.802667 22.408533-11.6224 39.6288-17.476267 51.6608-5.853867 12.032-15.581867 24.866133-29.201067 38.536533-13.6192 13.6704-29.0304 23.9104-46.267733 30.737067-17.237333 6.826667-37.512533 10.257067-60.842667 10.257067-22.6304 0-41.728-3.3792-57.309867-10.103467-15.581867-6.741333-26.658133-15.991467-33.245867-27.733333-6.587733-11.758933-9.915733-24.695467-9.966933-38.8096-0.0512-14.114133 3.413333-34.6624 10.3936-61.627733l27.374933-105.762133c8.209067-31.709867 18.8416-56.712533 31.880533-75.025067 13.038933-18.312533 30.293333-32.341333 51.729067-42.0864 21.435733-9.745067 44.4416-14.626133 69.000533-14.626133 30.0544 0 53.316267 5.870933 69.802667 17.629867 16.4864 11.758933 26.146133 27.323733 28.996267 46.728533 2.833067 19.4048-0.290133 46.6944-9.386667 81.851733L608.768 603.8016zM520.209067 473.719467c-7.424 0-12.629333 2.321067-15.581867 6.9632-2.9696 4.642133-7.099733 17.169067-12.373333 37.5808L485.376 544.768l31.2832 0 6.8608-26.504533c4.864-18.773333 7.0144-30.890667 6.485333-36.352C529.493333 476.450133 526.216533 473.719467 520.209067 473.719467zM431.342933 400.503467c-23.6032 10.376533-42.5984 25.2928-56.951467 44.782933-14.370133 19.490133-26.077867 46.08-35.106133 79.8208l-30.1568 112.5376c-7.68 28.689067-11.502933 50.551467-11.434667 65.570133 0.068267 15.018667 3.720533 28.791467 10.973867 41.284267 7.253333 12.509867 19.456 22.340267 36.608 29.508267 0.7168 0.290133 1.536 0.494933 2.2528 0.785067l-2.884267 10.496-128.529067 0-7.867733-248.4736L139.844267 785.271467 17.237333 785.271467l150.493867-546.56 122.606933 0 14.4384 246.101333 67.771733-246.101333 122.606933 0-42.427733 154.112C445.457067 394.990933 438.289067 397.448533 431.342933 400.503467z" fill="#FFFFFF" p-id="8686"></path></svg>
                        <div>热点新闻：2024-09-25 边缘骇客直播互动助手官网界面UI全面优化升级</div>
                        <a href="http://livehelper.willwaking.com/" target="_blank">查看详细</a>
                    </div>
                </div>
            </div>

        </div>
        <NaviagateMenu></NaviagateMenu>
    </div>
</template>

<script>
import BoundMenu from "@/components/BoundMenu.vue"
import NaviagateMenu from "@/components/NaviagateMenu.vue"
export default {
    components: {
        BoundMenu, NaviagateMenu
    },
    data() {
        return {
            music: false
        }
    },
    methods: {
        ListenMusic() {
            this.$refs.music.play()
            this.music = true
            console.log("开始播放数学派主题曲《数学系和银河系邂逅》")
        },
        CloseMusic() {
            this.$refs.music.pause()
            this.music = false
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.contain {
    display: flex;
}

.main {
    flex: 1;
    width: calc(100% - 350px);
    border-left: 1px solid #24273B;
    overflow-y: scroll;
}

.main-top {
    height: 40px;
    background-color: #151728;
    color: #4D516B;
    display: flex;
    align-items: center;
    padding-left: 15px;
    z-index: 2;
    position: sticky;
    top: 0;
}

.main-top-music {
    margin-left: auto;
    background-color: #42465e;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 15px;
}

.main-top-music span {
    color: #DEE0EC;
    margin-right: 15px;
}

.main-top-music svg {
    cursor: pointer;
}
.main-image {
    margin: 15px;
    background-color: #151728;
    position: relative;
    z-index: 1;
    height: 350px;
    overflow: hidden;
    background-image: url(./../assets/img/cover.jpg);
    background-size: cover;
    border-radius: 5px;
}

.main-image-line {
    height: 160px;
}

.main-image-info {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 0 15px;
    color: #FFFFFF;
    font-size: 50px;
    text-shadow: 1px 1px 1px #000;
}

.main-image-logo {
    width: 120px;
    height: 120px;
    margin-right: 15px;
    border-radius: 5px;
}

.image-menu {
    display: flex;
    height: 60px;
    align-items: center;
    background-color: #22253F55;
}

.main-image:before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    background-image: url("./../assets/img/cover.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    filter: blur(100px);
    opacity: 0.5;
}

.main-title {
    padding: 0 15px;
    height: 40px;
    display: flex;
    align-items: center;
    color: #4D516B;
    font-size: 25px;
    margin-top: 15px;
}

.latest-new {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    z-index: 1;
    background-color: #151728;
    height: 65px;
    color: #9AB4EB;
    align-items: center;
    padding: 0 15px;
    border-radius: 5px;
}

.latest-new svg {
    margin-right: 15px;
}
.latest-new a {
    background-color: #9AB4EB;
    border: none;
    line-height: 35px;
    height: 35px;
    color: white;
    padding: 0 15px;
    cursor: pointer;
    margin-left: auto;
    border-radius: 5px;
}

.latest-new div {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 15px;
}

.latest-new a:hover {
    background-color: #6C84B8;
}

.main-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px;
    margin-top: 0;
    margin-bottom: 0;
}

.main-bottom-date {
    width: 305px;
    height: 305px;
    background-color: #151728;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url(./../assets/img/time_background.jpg);
    border-radius: 5px;
}

.main-bottom-content {
    flex: 1;
    margin-left: 15px;
}
</style>